const inactivateEquipments = {
  toastr: 'Equipo Actualizados',
  toastr1: 'Equipo INACTIVADOS con éxito',
  toastr2: 'Equipo REACTIVADOS con éxito',
};

export default inactivateEquipments;
